import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { HistoricWorkflowCollection } from '../../Models/Domains/Workflow/HistoricWorkflowCollection';
import { IJsonDate } from '../../System/IJsonDate';
import { DemandType } from '../../Models/Domains/Workflow/DemandType';

declare var IS_RUNNING_IN_APP_POOL;

export class HistoricWorkflowClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(startDate: IJsonDate, endDate: IJsonDate, demandType: DemandType, policyNumber: string, start: number, count: number): Promise<HistoricWorkflowCollection, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/HistoricWorkflow/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { startDate: startDate, endDate: endDate, demandType: demandType, policyNumber: policyNumber, start: start, count: count }

    return AjaxWrapper.get<HistoricWorkflowCollection, any>(url, data);
  }
}

